import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { SettingsState } from '../../../statemanagement/settings.state';
import { filter, map, switchMap } from 'rxjs/operators';
import { MyRouter } from '../../../common/services/router.service';
import { isEmpty } from 'lodash-es';
import { AppSandbox } from '../../app.sandbox';
import { UserState } from '../../../statemanagement/user.state';

export const authenticationGuard = (
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot
) => {
    const router = inject(MyRouter);
    const appSandbox = inject(AppSandbox);
    const store = inject(Store);

    return store.pipe(
        select('settings'),
        filter((settings: SettingsState) => settings.ready),
        switchMap(() => store.pipe(select('user'))),
        map((user: UserState) => {
            if (user.loggedIn) {
                if (isEmpty(activatedRouteSnapshot.queryParams['corporate-client'])) {
                    router.navigateWithCorporateClient([routerStateSnapshot.url]);
                }
                return true;
            } else {
                appSandbox.logout();
                return false;
            }
        })
    );
};
